import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Button, Link, Stack } from "@mui/material";

import { Logo } from "@/components/atoms";
import { useNavigation } from "@/shared/hooks";

import { StyledFooter, StyledFooterDivider } from "./styled";

type FooterProps = {
    officeId: string | null;
};

const Footer: FC<FooterProps> = ({ officeId }) => {
    const { t } = useTranslation();
    const { navToCookiePolicyPage, navToPrivacyPolicyPage, navToTermsOfUsePage } = useNavigation();

    const footerLinks = [
        { onClick: () => navToPrivacyPolicyPage(officeId), testid: "privacy", text: t("Footer.PrivacyPolicy") },
        { onClick: () => navToCookiePolicyPage(officeId), testid: "cookies", text: t("Footer.CookiePolicy") },
        { onClick: () => navToTermsOfUsePage(officeId), testid: "terms", text: t("Footer.TermsOfUse") },
    ];
    return (
        <StyledFooter>
            <Button aria-label="MyBroker" variant="text" className="logo" onClick={() => window.scrollTo(0, 0)}>
                <Logo variant="default" officeId={officeId} />
            </Button>

            <Stack
                direction="row"
                divider={<StyledFooterDivider orientation="vertical" variant="middle" flexItem />}
                spacing={1}
                marginTop={2}
            >
                {footerLinks.map((link) => (
                    <Link
                        onClick={link.onClick}
                        key={`footer-link-${link.testid}`}
                        data-testid={`footer-link-${link.testid}`}
                        className="footerDividerText textUnderline"
                    >
                        {link.text}
                    </Link>
                ))}
            </Stack>
            <p className="footerText mt16">{t("Footer.CopyRightTemplate", { year: new Date().getFullYear() })}</p>
        </StyledFooter>
    );
};

export default Footer;
